// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonWatermark_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.946 15H21.5L23 24H1L3 15H8.05404C8.07842 13.9028 7.9807 12.7516 7.82532 11.5707C7.72446 10.8042 7.60676 10.0712 7.48938 9.34029C7.42736 8.95412 7.36543 8.56847 7.30613 8.17879C7.14107 7.0941 7 5.99737 7 5C7 2.23858 9.23858 0 12 0C14.7614 0 17 2.23858 17 5C17 5.99737 16.8589 7.0941 16.6939 8.17879C16.6346 8.56842 16.5727 8.95397 16.5107 9.34009C16.3933 10.071 16.2755 10.8042 16.1747 11.5707C16.0193 12.7516 15.9216 13.9028 15.946 15ZM12 3C13.1046 3 14 3.89543 14 5C14 5.75263 13.8911 6.6559 13.728 7.72746C13.6762 8.06781 13.6183 8.42898 13.5582 8.80352C13.4366 9.56132 13.3063 10.3739 13.2003 11.1793C13.0416 12.3854 12.9203 13.6821 12.9453 15H11.0547C11.0797 13.6821 10.9584 12.3854 10.7997 11.1793C10.6937 10.3739 10.5634 9.56134 10.4418 8.80352C10.3817 8.42898 10.3238 8.06781 10.272 7.72746C10.1089 6.6559 10 5.75263 10 5C10 3.89543 10.8954 3 12 3ZM5.40651 18L4.73985 21H19.4586L18.9586 18H5.40651Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonWatermark is a generated icon component.
 */
let IconCommonWatermark = IconCommonWatermark_1 = class IconCommonWatermark extends IconBaseElement {
    render() {
        return html `${IconCommonWatermark_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonWatermark.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonWatermark = IconCommonWatermark_1 = __decorate([
    customElement('zui-icon-common-watermark')
], IconCommonWatermark);
export { IconCommonWatermark };
